export default __webpack_public_path__ + "14502fa7b83595943cc004216280508a.png";